import { default as HealthSafetyEnvironmentRoutes } from "../_healthSafetyEnvironment/HealthSafetyEnvironmentRoutes";

const SitesRoutes = [
  ...HealthSafetyEnvironmentRoutes.map((obj) => ({
    ...obj,
    path: `/sites/:siteId${obj.path}`,
    nav: 2,
  })),
];

export default SitesRoutes;
